import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { appConfig } from '@/config';

/**
 * Sends GA4 page_view on client-side navigations.
 * The initial hit is already sent by gtag('config') in index.html.
 */
export function GoogleAnalytics() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (typeof window.gtag !== 'function') return;

    const pagePath = `${location.pathname}${location.search}`;

    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: window.location.href,
      page_path: pagePath,
      send_to: appConfig.gaMeasurementId,
    });
  }, [location.pathname, location.search]);

  return null;
}
